<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customerPass.actions.restore.title')"
    :info="$t('components.customerPass.actions.restore.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('components.customerPass.actions.restore.confirm'), type: 'confirm', variant: 'warning', callback: confirm },
    ]"
    :loading="loading"
    :portal="portal"
  />
</template>

<script setup lang="ts">
interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'update:customerPass', value: any): void
  (e: 'success'): void
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref<any>()
const item = ref<any>(null)

const open = (passItem: any) => {
  item.value = passItem
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.customerPass.restore(item.value)

    if (response.success) {
      emit('success')
      emit('update:customerPass', response.data)

      $bus.emit.updated('CustomerPass', item.value)

      $notification.toast({
        title: $i18n.t('components.customerPass.actions.restore.success'),
        text: $i18n.t('components.customerPass.actions.restore.successInfo'),
        variant: 'success',
      })

      emit('update:loading', false)

      return true
    }
  } catch (e) {
    console.log(e)
    $notification.toast({
      title: $i18n.t('general.error'),
      text: $i18n.t('components.customerPass.actions.restore.errorInfo'),
    })
  }

  emit('update:loading', false)
}

defineExpose({ open })
</script>
